<template>
  <Input
    class="t-InputTextColor"
    type="text"
    :value="value"
    @input="handle"
    :errorMessage="hasError"
  >
  </Input>
</template>

<script>
import Input from '../Input/Input.vue';

export default {
  components: { Input },
  props: {
    value: String,
    hasError: {
      type: String,
      default: '',
    },
  },
  methods: {
    handle(value) {
      this.$emit('setColor', value);
    },
  },
};
</script>
<style scoped>
.t-InputTextColor {
  width: 147px;
}
</style>
